module.exports = __webpack_public_path__ + "img/logo_full.49ccb990.png";